export default {
	setCatalog(state, catalog) {
		state.catalog = catalog
	},
}
